import React from "react";
import FoodAlbum from "./components/FoodAlbum";
import "./App.css";

function App() {
  return (
    <div className="App">
      <FoodAlbum />
    </div>
  );
}

export default App;
